import appAxios from "../../utils/appAxios.js";
export default {
    namespaced: true,
    state: {
        todayPlan: {
            CustomerName: null,
            LocationName: null,
            AuditDateTime: null,
            StatusName: null,
            StatusCode: 0,
            loading: false,
            DtotalRecord: 0

        },
        weekPlan: {
            CustomerName: null,
            LocationName: null,
            AuditDateTime: null,
            StatusName: null,
            StatusCode: 0,
            loading: false,
            WtotalRecord: 0

        },
        monthPlan: {
            CustomerName: null,
            LocationName: null,
            AuditDateTime: null,
            StatusName: null,
            StatusCode: 0,
            loading: false,
            MtotalRecord: 0

        },
        todayPlanList: [],
        weekPlanList: [],
        monthPlanList: [],
        totalRecordAudit: 0
    },

    getters: {

        _getTodayList: (state) => {
            state.todayPlanList;
        },
        _getWeekList: (state) => {
            state.weekPlanList;
        },
        _getMonthList: (state) => {
            state.monyhPlanList;
        },
        _DtotalRecord: (state) => {
            state.todayPlan.DtotalRecord
        },
        WtotalRecord: (state) => {
            state.weekPlan.WtotalRecord
        },
        MtotalRecord: (state) => {
            state.monthPlan.MtotalRecord
        },
    },


    actions: {

        async GET_ANALYSIS_CUSTOMERS(_, payload) {
            return new Promise(resolve => {
                appAxios.post("/admin/Report/GetCustomerAnalyticsData", payload).then(response => {
                    if (response.data.Success) {
                        resolve(response.data.Data)
                    }
                    else {
                        resolve(null)
                    }
                })
            })
        },
        async GET_CUSTOMER_AUDITPLANS(_, payload) {
            return new Promise(resolve => {
                appAxios.post("/admin/Report/GetCustomerAuditPlans", payload).then(response => {
                    if (response.data.Success) {
                        resolve(response.data.Data)
                    }
                    else {
                        resolve(null)
                    }
                })
            })
        },
        async GET_MONTH_AUDIT(_, payload) {
            return new Promise(resolve => {
                appAxios.get(`/admin/Home/GetAuditPlansOfThisMonth?pageIndex=${payload.pageIndex}&pageSize=${payload.pageSize}`).then(response => {
                    if (response.data.Success) {
                        resolve(response.data.Data)
                    }
                    else {
                        resolve(null)
                    }
                })
            })
        },

        async GET_WEEK_AUDIT(_, payload) {
            return new Promise(resolve => {
                appAxios.get(`/admin/Home/GetAuditPlansOfThisWeek?pageIndex=${payload.pageIndex}&pageSize=${payload.pageSize}`).then(response => {
                    if (response.data.Success) {
                        resolve(response.data.Data)
                    }
                    else {
                        resolve(null)
                    }
                })
            })
        },

        async GET_DAY_AUDIT(_, payload) {
            return new Promise(resolve => {
                appAxios.get(`/admin/Home/GetAuditPlansOfToday?pageIndex=${payload.pageIndex}&pageSize=${payload.pageSize}`).then(response => {
                    if (response.data.Success) {
                        resolve(response.data.Data)
                    }
                    else {
                        resolve(null)
                    }
                })
            })
        },
        async GET_APPROVAL_AUDITS(_, payload) {
            return new Promise(resolve => {
                appAxios.get(`/admin/Home/GetPendingAuditsForApproval?pageIndex=${payload.pageIndex}&pageSize=${payload.pageSize}`).then(response => {
                    if (response.data.Success) {
                        resolve(response.data.Data)
                    }
                    else {
                        resolve(null)
                    }
                })
            })
        },
        async GET_STATICS_BY_CUSTOMER(_, payload) {
            return new Promise(resolve => {
                appAxios.get(`/admin/Home/GetStatisticsByCustomer?pageIndex=${payload.pageIndex}&pageSize=${payload.pageSize}`).then(response => {
                    if (response.data.Success) {
                        resolve(response.data.Data)
                    }
                    else {
                        resolve(null)
                    }
                })
            })
        },
        async GET_APEXCHART_PERIOD(_, payload) {
            return new Promise(resolve => {
                appAxios.get(`admin/Home/GetAuditStatistics?period=${payload}`).then(response => {
                    if (response.data.Success) {
                        resolve(response.data.Data)
                    }
                    else {
                        resolve(null)
                    }
                })
            })
        },


        async GET_COMPANY_QUATO(_, payload) {
            return new Promise(resolve => {
                appAxios.get(`/admin/Home/GetCompanyQuota?pageIndex=${payload.pageIndex}&pageSize=${payload.pageSize}`).then((response) => {
                    if (response.data.Success) {
                        resolve(response.data.Data)
                    }
                    else {
                        resolve(null)
                    }
                })
            })
        }


    }


}
